import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./securityReviewSubmissionFailed.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { MAX_ASSET_UPLOAD_SIZE } from '~/config';
import { getSecurityReviewReport } from '~/modules/services/securityReviewService';
import { WireI18n } from '~/modules/stores/i18nStore';
import { securityReviewStore, selectFalsePositiveInFailedSR, selectSolution } from '~/modules/stores/securityReviewStore';
import { downloadContent } from '~/modules/utilities/fileUtilities';
import { notifyFailure } from '~/modules/utilities/notificationUtilities';
import { OpsSecurityOpsReviewStatus } from '~/modules/utilities/securityReviewUtilities';
class SecurityReviewSubmissionFailed extends LightningElement {
  constructor(...args) {
    super(...args);
    this.opsStatus = '';
    this.labels = {};
    this.notificationLabels = {};
    this.sharedLabels = {};
    this.solution = void 0;
    this.enableFalsePositiveDoc = false;
    this.maxAssetUploadSize = MAX_ASSET_UPLOAD_SIZE;
    this.falsePositiveDoc = void 0;
    this.isLoadingReport = false;
    this.securityReviewId = void 0;
  }
  i18nCallback(i18n) {
    this.labels = i18n.securityReviewSubmissionFailed;
    this.sharedLabels = i18n.shared;
    this.notificationLabels = i18n.notifications;
  }
  securityReviewStoreConnected(state) {
    this.opsStatus = state.securityReviewOps.status;
    this.solution = selectSolution(state);
    this.falsePositiveDoc = selectFalsePositiveInFailedSR(state);
    this.securityReviewId = state.securityReview.id;
  }
  async downloadFailedReportLink() {
    this.isLoadingReport = true;
    try {
      const securityReviewReport = await getSecurityReviewReport(this.securityReviewId);
      downloadContent(securityReviewReport.name, securityReviewReport.data);
    } catch (error) {
      var _error$response;
      if ((error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404) {
        notifyFailure(this.notificationLabels.securityReviewReportFileNotFound);
      } else {
        notifyFailure(this.notificationLabels.genericError);
      }
    } finally {
      this.isLoadingReport = false;
    }
  }
  get showFailed() {
    return this.opsStatus === OpsSecurityOpsReviewStatus.failedTest;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SecurityReviewSubmissionFailed, {
  track: {
    falsePositiveDoc: 1
  },
  wire: {
    i18nCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    },
    securityReviewStoreConnected: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: securityReviewStore
        };
      }
    }
  },
  fields: ["opsStatus", "labels", "notificationLabels", "sharedLabels", "solution", "enableFalsePositiveDoc", "maxAssetUploadSize", "isLoadingReport", "securityReviewId"]
});
const __lwc_component_class_internal = _registerComponent(SecurityReviewSubmissionFailed, {
  tmpl: _tmpl,
  sel: "appx-security-review-submission-failed",
  apiVersion: 62
});
export default __lwc_component_class_internal;